module.exports = __webpack_public_path__ + "img/qufu-name-3.35a23473.png";